import React, { useRef, useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { ICON_SAVE, ICON_CANCEL } from '../../extras/icons';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { saveServersAction, updateServersAction } from '../../../actions/serversActions';
import { Formik } from 'formik';
import ButtonSpinner from '../../layout/ButtonSpinner';
import * as yup from 'yup';
import { setLocale } from 'yup';
//Función principal
const ServerForm = props => {
    //Tomo los props
    const { show, handleClose } = props;
    //Genero los refs
    const refDescription = useRef();
    //Datos iniciales
    const initialData = {
        descripcion: '',
        ip: '',
        puerto: '',
        bd: ''
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const serversLoading = useSelector( state => state.servers.loadingSave );
    const errorSave = useSelector( state => state.servers.errorSave );
    const isEdit = useSelector( state => state.servers.isEdit );
    const serverSelected = useSelector( state => state.servers.serverSelected );
    //Inicializo el state local
    const [ server, setServer ] = useState(initialData);
    //Modifico según el cambio
    useEffect(() => {
        //Me fijo si es edición
        if(isEdit && serverSelected){
            setServer(serverSelected);
        }else{
            setServer(initialData);
        }
    }, [isEdit, serverSelected, show])
    //Manejo de cambios
    const handleChange = e => {
        setServer({
            ...server,
            [e.target.name]: e.target.value
        })
    }
    //Manejo el guardado
    const handleSave = values => {
        //Inicializo los datos
        let data = {
            ...server
        }
        //Agrego los nuevos valores
        data = {
            ...data,
            ...values
        }
        //Verifico si es edición o alta
        if(server.id){
            //Es edición
            dispatch( updateServersAction(data, handleCloseForm) );
        }else{
            //Es creación
            dispatch( saveServersAction(data, handleCloseForm) );
        }
    }
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Pongo el foco en el primer campo
        refDescription.current.focus();
    }
    //Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setServer(initialData);
        //Cierro
        handleClose();
    }
    //Esquema de validación
    const validationSchema = yup.object({
        descripcion: yup.string().required(),
        ip: yup.string().required(),
        puerto: yup.string().required(),
        bd: yup.string().required()
    });
    //Renderizo
    return (
        <Modal show={show} onHide={handleCloseForm} onShow={handleOnShow} aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Servidor&nbsp;
                    <small><strong>{ isEdit ? 'Editar' : 'Nuevo' } Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...server }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <Form.Group className="col-md-12">
                                    <label htmlFor="descripcion">Descripción</label>
                                    <Form.Control
                                        id="descripcion"
                                        className="form-control" 
                                        autoFocus 
                                        name="descripcion" 
                                        type="text" 
                                        value={ values.descripcion }
                                        onChange={handleChange}
                                        ref={refDescription}
                                        isInvalid={!!errors.descripcion}
                                        disabled={ serversLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.descripcion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-7">
                                    <label htmlFor="ip">IP</label>
                                    <Form.Control
                                        id="ip"
                                        className="form-control" 
                                        name="ip" 
                                        type="text" 
                                        value={ values.ip }
                                        onChange={handleChange}
                                        isInvalid={!!errors.ip}
                                        disabled={ serversLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.ip }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-5">
                                    <label htmlFor="puerto">Puerto</label>
                                    <Form.Control
                                        id="puerto"
                                        className="form-control" 
                                        name="puerto" 
                                        type="text" 
                                        value={ values.puerto }
                                        onChange={handleChange}
                                        isInvalid={!!errors.puerto}
                                        disabled={ serversLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.puerto }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="bd">Base de datos</label>
                                    <Form.Control
                                        id="bd"
                                        className="form-control" 
                                        name="bd" 
                                        type="text" 
                                        value={ values.bd }
                                        onChange={handleChange}
                                        isInvalid={!!errors.bd}
                                        disabled={ serversLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.bd }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                serversLoading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ serversLoading }>
                                        <ICON_SAVE /> <strong>{ isEdit ? 'ACTUALIZAR' : 'GUARDAR' }</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ serversLoading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default ServerForm;